module.exports = __webpack_public_path__ + "img/download_icon.dc525834.svg";